<template>
  <div class="basicCard">
    <div class="row">
      <div class="col-sm-2">
        <!--        <h5 class="cardTitles">School Name</h5>-->
        <h1>Upcoming<br />Schedule</h1>
      </div>
      <div class="col-sm-10">
        <div class="schedule">
          <div class="dayCard" v-for="day in upcomingSchedule" :key="day.id">
            <h5 class="cardTitles">
              {{ day.date.toString()[0] }}
              <span style="float: right">{{ day.date.getDate() }}</span>
            </h5>
            <p class="todayText" v-if="day.today">Today</p>
            <div class="redBar" v-if="day.today" :style="cssVars"></div>
            <div v-if="day.schedule.length">
              <div
                class="scheduleRow"
                v-for="item in day.schedule"
                :key="item.id"
              >
                <div>
                  <h6>
                    {{ item.startDisplayTime }}-{{ item.endDisplayTime }}
                    <span class="floatRight">{{ item.name }}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="noScheduledEvents">
                <h6>No Scheduled Events</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <br />
        <router-link to="/hilo/schedule">
          <hilo-button
            styleType="grey"
            label="View Full Schedule"
            style="float: right"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import HiloButton from "@/components/HiloComponents/HiloButton.vue";
import dayjs from "dayjs";
import EventsAPIService from "@/servicehandlers/EventsAPIService";
const eventsAPIService = new EventsAPIService();

export default {
  components: {
    HiloButton,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    idType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      events: [],
      upcomingSchedule: [],
    };
  },
  async mounted() {
    await this.getEvents();
    this.getUpcomingSchedule();
  },
  computed: {
    cssVars() {
      return {
        "--timeLoc": 25 + this.timeOffset() + "px",
      };
    },
  },
  methods: {
    async getEvents() {
      const startDateTime = dayjs().startOf("day").toISOString();
      const endDateTime = dayjs().add(4, "days").endOf("day").toISOString();
      const params = { startDateTime, endDateTime };

      try {
        if (this.idType === "userId") {
          this.events = await eventsAPIService.getEventsByUserIdAndDateRange(
            this.id,
            params,
          );
        } else if (this.idType === "activeStudentId") {
          this.events = await eventsAPIService.getEventsByStudentIdAndDateRange(
            this.id,
            params,
          );
        } else if (this.idType === "activeInstructorId") {
          this.events =
            await eventsAPIService.getEventsByInstructorIdAndDateRange(
              this.id,
              params,
            );
        } else if (this.idType === "dpeId") {
          this.events = await eventsAPIService.getEventsByDpeIdAndDateRange(
            this.id,
            params,
          );
        } else if (this.idType === "maintenance") {
          this.events = await eventsAPIService.getMaintenanceEvents(
            this.id,
            params,
          );
        }
      } catch (error) {}
    },
    getUpcomingSchedule() {
      this.upcomingSchedule = Array.from({ length: 5 }, (_, index) => {
        const date = dayjs().add(index, "day").toDate();
        return {
          id: index + 1,
          today: index === 0,
          date,
          schedule: [],
        };
      });

      this.events.forEach((event) => {
        const eventDate = dayjs(event.startDateTime).startOf("day");
        const daySchedule = this.upcomingSchedule.find((day) =>
          dayjs(day.date).isSame(eventDate, "day"),
        );

        if (daySchedule) {
          const startTime = dayjs(event.startDateTime);
          const endTime = dayjs(event.endDateTime);

          const startPeriod = startTime.format("A");
          const endPeriod = endTime.format("A");

          const startDisplayTime =
            startPeriod === endPeriod
              ? startTime.format("h:mm")
              : startTime.format("h:mm A");

          const endDisplayTime = endTime.format("h:mm A");
          daySchedule.schedule.push({
            startTime,
            startDisplayTime,
            endTime,
            endDisplayTime,
            name: event.eventType ? event.eventType.name : "Maintenance",
          });
        }
      });

      this.upcomingSchedule.forEach((day) => {
        day.schedule.sort((a, b) =>
          a.startTime.isBefore(b.startTime) ? -1 : 1,
        );
      });
    },
    timeOffset() {
      const hoursNow = dayjs().hour() + dayjs().minute() / 60;
      let offset = 0;
      const segmentHeight = 20;

      const todaySchedule =
        this.upcomingSchedule.find((day) => day.today)?.schedule || [];

      for (let event of todaySchedule) {
        const startTime =
          event.startTime.hour() + event.startTime.minute() / 60;
        const endTime = event.endTime.hour() + event.endTime.minute() / 60;

        if (startTime > hoursNow) break;

        if (startTime <= hoursNow && endTime >= hoursNow) {
          const progress = (hoursNow - startTime) / (endTime - startTime);
          offset += Math.floor(progress * segmentHeight);
          return offset;
        } else {
          offset += segmentHeight;
        }
      }

      return offset;
    },
  },
};
</script>

<style scoped>
.basicCard {
  margin: 30px 20px 0 0;
  border-color: transparent;
}
.cardTitles {
  padding: 0;
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: black;
}
.schedule {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 3em;
}
.dayCard {
  display: inline-block;
  border: #f0f0f0 3px solid;
  border-radius: 1.5em;
  padding: 1em 1.5em;
}
.todayText {
  font-size: 14px;
  color: #dd2025;
  float: right;
  padding: 0;
  margin: -5px 2px;
}
.scheduleRow,
.noScheduledEvents {
  padding: 0 1.5em;
  margin: 0 -1.5em;
  font-size: 18px;
  height: 20px;
}
.scheduleRow:first-child,
.noScheduledEvents:first-child {
  margin-top: 25px;
}
.scheduleRow:nth-child(odd) {
  background-color: #f0f0f0;
}
.noScheduledEvents {
  text-align: center;
}
.redBar {
  height: 2px;
  margin: 0 -1.5em;
  background-color: #dd2025;
  position: relative;
  top: var(--timeLoc);
}
.floatRight {
  float: right;
}
</style>
